<template>
  <div class="display-ticket-item-wrapper">
    <!-- <div class="avatar-wrapper">
      <van-image :src="value.logo" :width="50" :height="50" lazy-load fit="cover" />
    </div> -->
    <div class="description-wrapper">
      <p class="title">{{ value.ticket }}</p>
      <p v-if="value.ticket_two" class="description">{{ value.ticket_two }}</p>
    </div>
    <div class="price-wrapper">￥{{ value.price }}</div>
    <div class="action-wrapper">
      <van-button size="small" type="primary" @click="() => handlePurchase(value.id)"
        >购买</van-button
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: [Object],
  },
  methods: {
    handlePurchase(id) {
      this.$emit('purchase', id);
    },
  },
};
</script>
<style lang="less" scoped>
.display-ticket-item-wrapper {
  display: flex;
  align-items: center;
  padding: 10px 18px 16px;
  // border-bottom: 1px solid #fff;
  background: #fff;
  box-shadow: 0px 0px 1px 1px rgba(114, 119, 123, 0.1);
  margin-top: 8px;
  border-radius: 4px;
  .avatar-wrapper {
    margin-right: 12px;
    border-radius: 4px;
    height: 50px;
    overflow: hidden;
  }
  .description-wrapper {
    flex: 1;
    text-align: left;
    .description {
      color: #858b9c;
      font-size: 70%;
      margin-top: 8px;
    }
  }
  .price-wrapper {
    color: #ee0a24;
    font-size: 16px;
  }
  .action-wrapper {
    padding-left: 8px;
    /deep/ .van-button--primary {
      background-color: #45b97c;
      border: 1px solid #45b97c;
    }
  }
}
</style>
